import i18n from 'src/i18n/index.js';

class TypeOfProduct {
  constructor(productType) {
    this.productType = productType;
    this.isBasic = productType === 'MB';
    this.isAdditional = this.productType === 'AP';
    this.isExtraAdditional = ['XA', 'AE', 'KL', 'ER'].some((additionalType) => additionalType === this.productType);
    this.isDental = this.productType === 'TA';
    this.isExcess = this.productType === 'OW';
  }

  getTranslation() {
    if (this.isBasic) return i18n.global.t('productType.basic');
    if (this.isExtraAdditional) return i18n.global.t('productType.extra-additional');
    if (this.isAdditional) return i18n.global.t('productType.additional');
    if (this.isDental) return i18n.global.t('productType.dental');
    if (this.isExcess) return i18n.global.t('productType.excess');
    return undefined;
  }

  getTranslationWithYour() {
    if (this.isBasic) return i18n.global.t('productType.your-basic');
    if (this.isExtraAdditional) return i18n.global.t('productType.your-extra-additional');
    if (this.isAdditional) return i18n.global.t('productType.your-additional');
    if (this.isDental) return i18n.global.t('productType.your-dental');
    if (this.isExcess) return i18n.global.t('productType.your-excess');
    return undefined;
  }

  getTranslationWithChoose() {
    if (this.isBasic) return i18n.global.t('productType.choose-basic');
    if (this.isExtraAdditional) return i18n.global.t('productType.choose-extra-additional');
    if (this.isAdditional) return i18n.global.t('productType.choose-additional');
    if (this.isDental) return i18n.global.t('productType.choose-dental');
    if (this.isExcess) return i18n.global.t('productType.choose-excess');
    return undefined;
  }

  getIcon() {
    if (this.isBasic) return 'img:statics/icons/icon-care.svg';
    if (this.isExtraAdditional) return 'img:statics/icons/icon-heart.svg';
    if (this.isAdditional) return 'img:statics/icons/icon-heart.svg';
    if (this.isDental) return 'img:statics/icons/icon-tooth.svg';
    if (this.isExcess) return 'fas fa-euro-sign';
    return undefined;
  }
}

export { TypeOfProduct as default };
